/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { FunctionComponent, memo, ReactNode } from 'react';
import Flag from 'react-world-flags';
import { I_MenuPortfolio, I_Portfolio } from '../typesIndex';

export interface I_SocialsProps {
  isShowType?: boolean;
  className?: string;
  user?: I_Portfolio['user'];
}

export interface I_MenuProps {
  menu?: I_Portfolio['menu'];
  menuCollectionSelected: string;
  onChangeCollectionPortfolio: (
    type: I_MenuPortfolio['type'],
    value: string,
  ) => void;
}

export interface I_UserInfoProps {
  user?: I_Portfolio['user'];
  slug?: I_Portfolio['slug'];
  isHideSlug?: boolean;
  avatarClass?: string;
  wrapperClass?: string;
  childrenAboveBio?: ReactNode;
  childrenBelowBio?: ReactNode;
}

export interface I_LogoProps {
  logo?: I_Portfolio['user']['logo'];
  home_page?: I_Portfolio['user']['home_page'];
}

export interface I_CoverProps {
  cover?: I_Portfolio['user']['cover'];
  className?: string;
}

export interface I_HeaderGeneralComponent extends FunctionComponent {
  Menu: typeof Menu;
  Socials: typeof Socials;
}

function HeaderGeneral() {
  return <div />;
}

function Socials({ isShowType, className, user }: I_SocialsProps) {
  return (
    <div className="portContact">
      <ul className={className}>
        {user?.socials.map((item, index) => (
          <li key={index}>
            <a
              target="_blank"
              rel="noreferrer"
              href={`${item.type === 'mail' ? 'mailto:' : ''}${item.value}`}
              title={item.type}
            >
              <i aria-hidden className={item.icon} />
              {isShowType && (
                <span>{item.type !== 'other' ? item.type : item.value}</span>
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function Menu({
  menu,
  menuCollectionSelected,
  onChangeCollectionPortfolio,
}: I_MenuProps) {
  return (
    <ul className="d-flex">
      {menu
        ?.filter(item => item.id !== 'Panoee_Default')
        ?.map(item => (
          <li
            key={item.id}
            className={`itemPortMenu ${
              item.type === 'collection' && item.id === menuCollectionSelected
                ? '--active'
                : ''
            }`}
            onClick={() =>
              onChangeCollectionPortfolio(
                item.type,
                item.type === 'collection' ? item.id : item.link,
              )
            }
          >
            <h2 className="--portMenuTitle">{item.name}</h2>
            {item.type === 'link' ? (
              <i aria-hidden className="far fa-arrow-up-right-from-square" />
            ) : (
              <i aria-hidden className="fas fa-grid d-none" />
            )}
          </li>
        ))}
    </ul>
  );
}

function UserInfo({
  user,
  slug,
  avatarClass = '',
  wrapperClass = '',
  childrenAboveBio,
  childrenBelowBio,
  isHideSlug = false,
}: I_UserInfoProps) {
  return (
    <div className={`--wrapper ${wrapperClass}`}>
      <div className={`--avatar ${avatarClass}`}>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href={user?.home_page || ''}
          title="home page"
        >
          <img
            src={user?.avatar || process.env.NEXT_PUBLIC_DEFAULT_AVATAR}
            alt="avatar"
            title="avatar"
          />
        </a>
      </div>
      <div className="--info">
        {(user?.first_name || user?.last_name || !isHideSlug) && (
          <h1 className="--name">
            {user?.first_name || user?.last_name
              ? `${user?.first_name} ${user?.last_name}`
              : !isHideSlug
              ? `@${slug}`
              : ''}
            {(user?.first_name || user?.last_name) && !isHideSlug && (
              <small>@{slug}</small>
            )}
          </h1>
        )}
        {(user?.nationality || user.address) && (
          <div className="--locale">
            <i aria-hidden className="far fa-location-dot" />
            {user?.address}{' '}
            {user?.nationality && (
              <span className="--flag">
                <Flag code={user?.nationality} height="12" />
              </span>
            )}
          </div>
        )}
        {childrenAboveBio}
        <div
          className="--bio"
          dangerouslySetInnerHTML={{
            __html: user?.bio || '',
          }}
        />
        {childrenBelowBio}
      </div>
    </div>
  );
}

function Logo({ logo, home_page }: I_LogoProps) {
  return (
    <a target="_blank" rel="noreferrer noopener" href={home_page} title={logo}>
      {logo ? (
        <div className="--logo">
          <img src={logo} title="logo" alt="logo" />
        </div>
      ) : (
        <div />
      )}
    </a>
  );
}

function Cover({ cover, className = '--img' }: I_CoverProps) {
  return (
    <img
      src={cover || 'img/vtour.webp'}
      title="cover"
      alt="cover"
      className={className}
    />
  );
}

HeaderGeneral.Logo = memo(Logo);
HeaderGeneral.Cover = memo(Cover);
HeaderGeneral.Menu = memo(Menu);
HeaderGeneral.Socials = memo(Socials);
HeaderGeneral.UserInfo = memo(UserInfo);

export default HeaderGeneral;
